import { render, staticRenderFns } from "./WDO.vue?vue&type=template&id=3f637128&scoped=true"
import script from "./WDO.vue?vue&type=script&lang=js"
export * from "./WDO.vue?vue&type=script&lang=js"
import style0 from "./WDO.vue?vue&type=style&index=0&id=3f637128&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f637128",
  null
  
)

export default component.exports